import { Link } from "react-router-dom";

export default function AboutMe(): JSX.Element {
  return (
    <div className="AboutMe">
      <Link to="/" id="homeLink">
        Home
      </Link>
      <h2 id="h2AM">About Me </h2>
      <div className="text">
        <p>
          I&apos;m a recent graduate from the University of Manchester with a
          BEng in Chemical Engineering and a strong passion for technology. I
          have experience in full-stack web development, particularly in
          front-end technologies such as React and TypeScript, and back-end
          technologies such as Node.js and Express.
        </p>
        <br />
        <p>
          I have experience working on a variety of personal projects, including
          a web app that shows details of a user&apos;s collection of NFTs and a
          portfolio website. I also have experience working as an intern at
          Media Lab AI and an coding academy for full-stack web development.
        </p>
        <br />
        <p>
          I am passionate about web development, Software development and new
          innovation in technology!
        </p>
      </div>
    </div>
  );
}
